import { render, staticRenderFns } from "./AppEvent.vue?vue&type=template&id=5b0bd8ca&"
import script from "./AppEvent.vue?vue&type=script&lang=js&"
export * from "./AppEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports